export default __webpack_public_path__ + "/dist/images/inquiry.2e9c6a4f3ca977d2527acfe93bc8e2b8.svg";